import styled from 'styled-components/macro';

import { SubTitle } from 'components/common/fontElements';

export const SharepointHeaderWrapper = styled.div`
  display: flex;
  align-items: center;

  & ${SubTitle} {
    margin-right: 4px;
  }
`;

export const ThumbnailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 60px);
  grid-auto-rows: 44px;
  grid-gap: 4px;
  margin: 0 -4px;
`;
